import { request } from "../_helpers/Auth";

const namespace = "/api/shift";

export const attachShift = (payload) => {
    return request({
        url: namespace + "/attach",
        method: "post",
        data: payload,
    });
};

export const detachShift = (payload) => {
    return request({
        url: namespace,
        method: "delete",
        data: payload,
    });
};

export const getShifts = () => {
    return request({
        url: namespace + "s",
        method: "get",
    });
};
